module.exports = __webpack_public_path__ + "img/icon.0837a2bd.svg";